import { attach, sample } from 'effector'

import { getRegisterInfo } from '@portal/client-info'

import { portalProfileAPI } from '@/entities/profile/portal'
import { $lang, attachI18n } from '@/shared/lib/i18n'
import { navigateTo } from '@/shared/lib/next'
import { toast } from '@/shared/lib/toast'
import { modal } from '@/shared/ui/modal'

export const googleLoginFx = attach({
    effect: portalProfileAPI.googleLogin,
    source: $lang,
    mapParams({ accessToken }: { accessToken: string }, lang) {
        return {
            access_token: accessToken,
            register_info: getRegisterInfo(lang),
        }
    },
})

sample({
    clock: googleLoginFx.done,
    target: [modal.closeAll, navigateTo('/play', { replace: true })],
})

sample({
    clock: googleLoginFx.fail,
    target: attachI18n(toast.errorFx, 'TEXT_TOAST_FAIL'),
})
